// eslint-disable-next-line no-restricted-imports
import * as yup from 'yup';

/**
 * yupのsetLocaleの動的実行でバグがあるため、yupをラップして必ず最初にsetLocaleが呼び出されるようにします。
 *
 * https://github.com/jquense/yup/pull/1371
 * https://github.com/jquense/yup/issues/293
 */
yup.setLocale({
  mixed: {
    required: ({ label }) => `${label}を入力してください。`,
    notNull: ({ label }) => `${label}を入力してください。`,
  },
  string: {
    max: ({
      label,
      max,
    }) => `${label}は${max}文字以内で入力してください。`,
    length: ({
      label,
      length,
    }) => `${label}は${length}桁で入力してください。`,
  },
  number: {
    min: ({
      label,
      min,
    }) => `${label}は${min}以上で入力してください。`,
    max: ({
      label,
      max,
    }) => `${label}は${max}以下で入力してください。`,
    integer: ({ label }) => `${label}は整数で入力してください。`,
    moreThan: ({
      label,
      more,
    }) => `${label}は${more}より大きい数字を入力してください。`,
  },
  date: {
    min: ({ label }) => `${label}は現在日時より後の日時を入力してください。`,
  },
  array: {
    min: ({ label }) => `${label}を選択してください。`,
    max: ({ label }) => `選択できる${label}の件数を超えています。`,
  },
});

export const {
  string,
  number,
  boolean,
  object,
  date,
  array,
  bool,
  mixed,
  tuple,
} = yup;

type Maybe<T> = yup.Maybe<T>;
type Flags = yup.Flags;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ISchema<T, C = any, F extends Flags = any, D = any> = yup.ISchema<T, C, F, D>;
export type AnyObject = yup.AnyObject;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ObjectSchema<TIn extends Maybe<AnyObject>, TContext = AnyObject, TDefault = any, TFlags extends Flags = ''> = yup.ObjectSchema<TIn, TContext, TDefault, TFlags>;

/**
 * yupのInferTypeで取得した型からオプショナルフラグ`?`を削除して、引数を省略して値を定義できないようにします。
 * InferTypeの型はAPIのリクエストパラメータとして使うことが多く、かつAPIのパラメータの引数がしばしば数が多くなるため、
 * 変更を型で検知しやすくするために`?`を消します。
 */
type DeepRemoveOptional<T> = {
  [P in keyof Required<T>]-?:
  T[P] extends Array<(infer U)>
    ? Array<DeepRemoveOptional<U>>
    // eslint-disable-next-line @typescript-eslint/ban-types
    : T[P] extends Function
      ? T[P]
      : DeepRemoveOptional<T[P]>
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type InferType<T extends ISchema<any, any, any, any>> = DeepRemoveOptional<yup.InferType<T>>;
